import { render, staticRenderFns } from "./GooglePayButton.vue?vue&type=template&id=a95b7a16&scoped=true"
import script from "./GooglePayButton.vue?vue&type=script&lang=js"
export * from "./GooglePayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b7a16",
  null
  
)

export default component.exports